import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Iate Morningstar · 200 m² em Vilamoura";
const DESC = "Conheça o Morningstar — um iate privado de 200 m² baseado na Marina de Vilamoura. 18 pessoas, solário, lounge à sombra, casa de banho, plataforma de banho e tripulação profissional.";
const PATH = "/pt/o-morningstar";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/pt/o-morningstar")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: "O Iate · Vilamoura · Algarve",
        title: "Conheça o ",
        titleAccent: "Morningstar.",
        sub: "200 m² de convés em teca, lounge à sombra, almofadas de proa, casa de banho em mármore e plataforma de banho — o maior iate privado de day-charter da Marina de Vilamoura, até 18 pessoas.",
        ctaPrimary: "Ver especificações",
        ctaSecondary: "Marcar visita",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "morningstar iate, morningstar vilamoura, iate 18 pessoas vilamoura, iate algarve especificações",
      altPath: { en: "/the-morningstar", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Morningstar Private Yacht",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "O Morningstar", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("pt")) },
      ],
    }),
});
